module.exports = {
    API_TITLE:"北京中加学校 & 北京通州华仁学校 官方网站", //项目名称
	// testdomainName: "https://api.bccsc.com.cn", //本地：正式
	testdomainName: "https://testapi.bccsc.com.cn", //本地：测试
	domainName: "https://api.bccsc.com.cn", //线上域名：正式
	// domainName: "https://testapi.bccsc.com.cn", //线上域名：测试
    interfacePrefix:"", //接口前缀
    port:8040, //本地端口
    assetsPublicPath:"./", //打包后服务器文件路径
    
}


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 16